import ReportWithoutCriteria from '../ReportWithoutCriteria';
import {
  INTERCOM_ACTIVE_USERS_REPORT_ERROR,
  INTERCOM_ACTIVE_USERS_REPORT_LOADING,
  INTERCOM_ACTIVE_USERS_REPORT_SUCCESS,
} from './reportStates';

export default function IntercomActiveUsersReport({
  getLatestIntercomActiveUsersReport,
  generateIntercomActiveUsersReport,
  intercomActiveUsersReport,
}) {
  return (
    <ReportWithoutCriteria
      name="Intercom Active Users Report"
      link={intercomActiveUsersReport.data.link}
      currentState={intercomActiveUsersReport.state}
      stateLoading={INTERCOM_ACTIVE_USERS_REPORT_LOADING}
      stateError={INTERCOM_ACTIVE_USERS_REPORT_ERROR}
      stateSuccess={INTERCOM_ACTIVE_USERS_REPORT_SUCCESS}
      getLatestFunc={getLatestIntercomActiveUsersReport}
      generateFunc={generateIntercomActiveUsersReport}
    />
  );
}
